import PropTypes from 'prop-types';
import fr from 'facet-rest';
import moment from 'moment';

class Agent {
  constructor() {
    this.id = 0;
    this.userID = 0;
    this.firstName = '';
    this.middleName = '';
    this.lastName = '';
    this.title = '';
    this.nickname = '';
    this.certificationTitle = '';
    this.email = '';
    this.teamCoach = null;
    this.teamCoachID = '';
    this.role = '';
    this.createdAt = null;
    this.personID = 0;
    this.calendarURL = '';
    this.profileURL = '';
    this.dateOfCertification = null;
    this.effectiveDate = null;
    this.address = null;
    this.city = null;
    this.state = null;
    this.zip = null;
    this.disciplinaryAction = null;
    this.otherBusinessActivities = null;
    this.additionalCompensation = null;
    this.biography = null;
    this.isTestUser = 'false';
    this.isSaveAgent = 'false';
    this.isWaitListAgent = 'false';
    this.zoomUrl = '';
    this.isTransition = 'false';
    this.chilipiperCalendarLink = '';
  }
}

export default Agent;

export const propTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  userID: PropTypes.number.isRequired,
  firstName: PropTypes.string.isRequired,
  middleName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  nickname: PropTypes.string.isRequired,
  certificationTitle: PropTypes.string,
  email: PropTypes.string.isRequired,
  teamCoach: PropTypes.object.isRequired,
  teamCoachID: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  createdAt: PropTypes.instanceOf(moment),
  personID: PropTypes.number.isRequired,
  profileURL: PropTypes.string.isRequired,
  dateOfCertification: PropTypes.string.isRequired,
  effectiveDate: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  zip: PropTypes.string.isRequired,
  disciplinaryAction: PropTypes.string.isRequired,
  otherBusinessActivities: PropTypes.string.isRequired,
  additionalCompensation: PropTypes.string.isRequired,
  biography: PropTypes.string.isRequired,
  isTestUser: PropTypes.bool.isRequired,
  isSaveAgent: PropTypes.bool.isRequired,
  isWaitListAgent: PropTypes.bool.isRequired,
  isTransition: PropTypes.bool.isRequired,
  zoomUrl: PropTypes.string,
  chilipiperCalendarLink: PropTypes.string,
  resource: PropTypes.object,
});

export const fromAPIResponse = (res) => {
  const defaults = {
    teamCoach: null,
    createdAt: null,
  };

  // maybe res will have data, maybe it'll have attributes, who knows?
  if (!res) {
    return new Agent();
  }
  const attrs = res.data ? res.data.attributes : res.attributes;
  const resource = res.data ? fr.resource(res.data) : fr.resource(res);
  const agent = Object.assign(new Agent(), attrs, defaults, { id: res.id });
  agent.resource = resource;
  // transform the team coach if it exists
  if (attrs.teamCoachID !== '0' && attrs.teamCoachID !== '') {
    agent.teamCoach = fromAPIResponse(attrs.teamCoach);
  }

  // parse the created at time
  if (attrs.createdAt) {
    agent.createdAt = moment(attrs.createdAt);
  }
  return agent;
};

export const toAPIRequest = agent => {
  const req = {
    type: 'agent',
    id: agent.id,
    attributes: {
      teamCoachID:
      Number.parseInt(agent.teamCoachID, 10) > 0 ? agent.teamCoachID : null,
      firstName: agent.firstName,
      middleName: agent.middleName,
      lastName: agent.lastName,
      title: agent.title,
      nickname: agent.nickname,
      certificationTitle: agent.certificationTitle,
      email: agent.email,
      teamCoach: agent.teamCoach,
      role: agent.role,
      createdAt: agent.createdAt,
      personID: agent.personID,
      calendarURL: agent.calendarURL,
      profileURL: agent.profileURL,
      dateOfCertification: agent.dateOfCertification,
      effectiveDate: agent.effectiveDate,
      address: agent.address,
      city: agent.city,
      state: agent.state,
      zip: agent.zip,
      disciplinaryAction: agent.disciplinaryAction,
      otherBusinessActivities: agent.otherBusinessActivities,
      additionalCompensation: agent.additionalCompensation,
      biography: agent.biography,
      isTestUser: agent.isTestUser,
      isSaveAgent: agent.isSaveAgent,
      isWaitListAgent: agent.isWaitListAgent,
      isTransition: agent.isTransition,
      zoomUrl: agent.zoomUrl,
      chilipiperCalendarLink: agent.chilipiperCalendarLink,
    },
  };

  if (req.attributes.teamCoach) {
    req.attributes.teamCoach.resource = undefined;
  }

  return req;
};

export const PLANNING_TEAM_LEAD = 'PlanningTeamLead';
export const LEAD_PLANNER = 'LeadPlanner';
export const CS_TEAM_LEAD = 'CSTeamLead';
export const CSM = 'ClientSuccessManager';
